import request from '@/config/axios'

export const getHeroList = () => request.get({ url: '/rental/home/hero/list' })
export const getHero = (id: number) => request.get({ url: '/rental/home/hero/get', params: { id } })
export const createHero = (data: any) => request.post({ url: '/rental/home/hero/create', data })
export const updateHero = (data: any) => request.put({ url: '/rental/home/hero/update', data })
export const deleteHero = (id: number) => request.delete({ url: '/rental/home/hero/delete', params: { id } })
